import React, { useState } from "react";
import "./updateParent.scss";

import { Close, Person2Sharp } from "@mui/icons-material";

import "react-phone-input-2/lib/style.css";
// import ReactFlagsSelect from "react-flags-select";
import { IconButton } from "@mui/material";
import {
  domaineType,
  fonctionType,
  gradeType,
  ParentType,
  requestType,
} from "../../../types/GlobalType.ts";
import toast, { LoaderIcon } from "react-hot-toast";
import { accountService } from "../../../_services/accountServices.js";
import { catchErrorApiCall } from "../../../_services/apiUtils.js";
import ErrorBar from "../../../component/errorComp/ErrorBar.tsx";
import { useNavigate } from "react-router-dom";
import { API_PARENT } from "../../../apiCaller/perent.Callerl.js";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<Boolean>>;
  data: ParentType | undefined;
  dataFonction: fonctionType[];
  dataGrade: gradeType[];
  dataDomaine: domaineType[];
  dispatchReload: () => void;
}
const UpdateParent = (props: Props) => {
  // console.log(props.data?.nom);

  const navigate = useNavigate();
  const [personnelData, setpersonnelData] = useState({
    nom: props.data?.nom,
    postnom: props.data?.postnom,
    prenom: props.data?.prenom,
    sexe: props.data?.sexe,
    telephone: props.data?.telephone,
    ville: props.data?.ville,
    commune: props.data?.commune,
    quartier: props.data?.quartier,
    avenue: props.data?.avenue,
  });

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const handleChange = (e) => {
    setpersonnelData({ ...personnelData, [e.target.name]: e.target.value });
  };

  const handleUpdate = async () => {
    if (
      !personnelData.nom?.toString().length ||
      !personnelData.postnom?.toString().length ||
      !personnelData.prenom?.toString().length ||
      !personnelData.ville?.toString().length ||
      !personnelData.commune?.toString().length ||
      !personnelData.quartier?.toString().length ||
      !personnelData.telephone?.toString().length ||
      !personnelData.avenue?.toString().length
    ) {
      return setState({
        ...state,
        errorMessage: "Veuiller complétez tous les champs",
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }

    try {
      let data = {
        nom: personnelData.nom,
        postnom: personnelData.postnom,
        prenom: personnelData.prenom,
        sexe: personnelData.sexe,
        ville: personnelData.ville,
        commune: personnelData.commune,
        quartier: personnelData.quartier,
        avenue: personnelData.avenue,
        telephone: personnelData.telephone,
      };
      const response = await API_PARENT.PARENT.update(
        props.data?.parent_id,
        data,
        token,
      );

      // console.log(response);
      if (response.data.status === 200) {
        toast.success("Mis à jour effectuée avec succès", { duration: 3000 });
        props.setOpen(false);
        props.dispatchReload();
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
            zIndex: 9999,
          },
        });
      }
    } catch (error) {
      // console.log(error);
      setState({ ...state, isLoading: false });
      catchErrorApiCall(error);
    }
  };

  //phone number state
  // const [phoneNumber, setPhoneNumber] = useState("");

  // const [selectedCountry, setSelectedCountry] = useState<string>("CD");
  return (
    <div className="UpdatePersonnel">
      <div className="dialog_update">
        <div className="headerUpdate">
          <div className="titleUpdate">
            <div className="left_">
              <Person2Sharp className="ico" />
              <span>Modification Parent</span>
            </div>
            <IconButton>
              <Close className="ico" onClick={() => props.setOpen(false)} />
            </IconButton>
          </div>
        </div>

        <div className="body_update">
          {state.errorMessage && <ErrorBar title={state.errorMessage} />}

          <div className="item">
            <label>Nom *</label>
            <input
              placeholder="Nom..."
              type="text"
              name="nom"
              value={personnelData.nom?.toUpperCase()}
              onChange={handleChange}
            />
          </div>
          <div className="item">
            <label>Post-nom *</label>
            <input
              placeholder="Post-nom..."
              type="text"
              name="postnom"
              value={personnelData.postnom?.toUpperCase()}
              onChange={handleChange}
            />
          </div>
          <div className="item">
            <label>Prénom *</label>
            <input
              placeholder="Prénom..."
              type="text"
              name="prenom"
              value={personnelData.prenom?.toUpperCase()}
              onChange={handleChange}
            />
          </div>

          <div className="item">
            <label>Genre</label>
            <select
              onChange={handleChange}
              name="sexe"
              value={personnelData.sexe?.toUpperCase()}
            >
              <option value="M">Masculin</option>
              <option value="F">Feminin</option>
            </select>
          </div>
          <div className="item">
            <label>Téléphone*</label>
            <input
              placeholder="Téléphone..."
              type="text"
              name="telephone"
              value={personnelData.telephone}
              onChange={handleChange}
            />
          </div>

          {/* <div className="item country">
            <label>Pays</label>
            <ReactFlagsSelect
              selected={selectedCountry}
              onSelect={(code) => setSelectedCountry(code)}
              optionsSize={13}
              selectedSize={13}
              searchPlaceholder="Chercher pays"
              placeholder="Choix du pays"
              searchable
              className="menu-flags"
              selectButtonClassName="menu-flags-button"
            />
          </div> */}

          <div className="item">
            <label>Ville *</label>
            <input
              placeholder="Ville..."
              type="text"
              name="ville"
              value={personnelData.ville?.toUpperCase()}
              onChange={handleChange}
            />
          </div>

          <div className="item">
            <label>Commune *</label>
            <input
              placeholder="Commune..."
              type="text"
              name="commune"
              value={personnelData.commune?.toUpperCase()}
              onChange={handleChange}
            />
          </div>

          <div className="item">
            <label>Quartier *</label>
            <input
              placeholder="Quartier..."
              type="text"
              name="quartier"
              value={personnelData.quartier?.toUpperCase()}
              onChange={handleChange}
            />
          </div>
          <div className="item">
            <label>Avenue *</label>
            <input
              placeholder="Avenue..."
              type="text"
              name="avenue"
              value={personnelData.avenue?.toUpperCase()}
              onChange={handleChange}
            />
          </div>

          {/* <div className="item phone">
          <label>Téléphone *</label>
          <PhoneInput
            country={"cd"}
            value={phoneNumber}
            onChange={handleChangePhone}
          />
          {!validdNumber && (
            <span style={{ color: "red", fontSize: "12px" }}>
              Entrer un numéro valide
            </span>
          )}
        </div> */}
        </div>
        <div className="btn">
          <button onClick={() => props.setOpen(false)}>Annuler</button>
          {state.isLoading ? (
            <button>
              <LoaderIcon />
            </button>
          ) : (
            <button onClick={handleUpdate}>Mettre à jour</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdateParent;
